module.exports = __webpack_public_path__ + "Roboto-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Medium.eot
// module id = 29
// module chunks = 0